import styled from 'styled-components'

export const Container = styled.main`
  width: 100%;
  height: 100%;
  padding: 2rem;
  box-sizing: border-box;
`
